import { ApiResponse, LoadOptions } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoint } from './endpoints';
import { ExtraInfoCodeValues } from 'app/components/access-panel/shared/types';
import { SearchApiResponse } from 'app/area/administration/list/types';

export const editApi = {
  getExtraInfo: () => {
    return new RemoteAdminData(endpoint.extraInfo)
      .resource<ApiResponse<ExtraInfoCodeValues[]>>()
      .single();
  },
  getPersonOptions: async () => {
    const response = await new RemoteAdminData(endpoint.personExcluded)
      .resource<ApiResponse<any>>()
      .single();
    return response.data;
  },
  getUsers: async (loadOptionsParams: LoadOptions) => {
    const response: any = await new RemoteAdminData(endpoint.users)
      .resource<ApiResponse<SearchApiResponse>>()
      .create(loadOptionsParams, false);

    return await response.json();
  }
};
